import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { TenantContextService } from "../services/tenant-context.service";

/**
 * Route gate driven by the active tenant's `type` field.
 *
 * Usage:
 *   { path: "maqraa/dashboard", canActivate: [OrgTypeGuard("maqraa")] }
 *
 * Super-admins bypass the gate so they can impersonate any tenant.
 */
export function OrgTypeGuard(requiredType: "institute" | "maqraa"): CanActivateFn {
  return () => {
    const ctx = inject(TenantContextService);
    const router = inject(Router);

    if (ctx.isSuperAdmin()) return true;
    if (ctx.orgType() === requiredType) return true;

    router.navigateByUrl("/home");
    return false;
  };
}
